export const settings = {
  title: 'Settings',
  description: 'Adjust your personal preferences.',
};
